// Pure helper for the catalogue's inline preview: once a card's preview is
// selected, does that id still have a matching item in the current results?
//
// Extracted out of KitsCatalogue.jsx (mirrors how lruCache.js/patternGeometry.js
// isolate pure logic elsewhere in this codebase) so the "stop playback when
// the playing card scrolls out of the results" check is a plain function of
// its inputs -- unit-testable without mounting the component, driving Web
// Audio, or faking a fetch.
export function isSelectionVisible(selectedId, items) {
  if (selectedId == null) return true; // nothing selected -- vacuously fine
  if (!Array.isArray(items)) return false;
  return items.some((item) => item?.id === selectedId);
}
